import React from 'react'
import { colors } from '../../../styles/vars/colors.style'
import { ViewMoreCircle, ViewMoreSvg, ViewMoreIcon } from './index.style'

const ViewMore = ({
  width = 100,
  height = 100,
  stroke = colors.light,
  responsive = false,
  active = true,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <ViewMoreSvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      focusable="false"
      role="img"
      {...svgAttributes}
    >
      <ViewMoreCircle
        active={active}
        r="49.5"
        cx="50"
        cy="50"
        stroke={stroke}
        transform="rotate(-90, 50, 50)"
      />

      <ViewMoreIcon active={active}>
        <path stroke={stroke} strokeWidth="2" d="m55.707 54.293 9 9" />

        <rect
          x="36"
          y="36"
          width="22"
          height="22"
          rx="11"
          stroke={stroke}
          strokeWidth="2"
        />
      </ViewMoreIcon>
    </ViewMoreSvg>
  )
}

export default ViewMore
